import { render, staticRenderFns } from "./aiReportForm.vue?vue&type=template&id=0fa0f73c"
import script from "./aiReportForm.vue?vue&type=script&lang=js"
export * from "./aiReportForm.vue?vue&type=script&lang=js"
import style0 from "./aiReportForm.vue?vue&type=style&index=0&id=0fa0f73c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports